__turbopack_context__.v({
  "actions": "NavigationButtons-module-scss-module__t4Cz0G__actions",
  "button": "NavigationButtons-module-scss-module__t4Cz0G__button",
  "buttonIcon": "NavigationButtons-module-scss-module__t4Cz0G__buttonIcon",
  "item": "NavigationButtons-module-scss-module__t4Cz0G__item",
  "link": "NavigationButtons-module-scss-module__t4Cz0G__link",
  "primary": "NavigationButtons-module-scss-module__t4Cz0G__primary",
  "secondary": "NavigationButtons-module-scss-module__t4Cz0G__secondary",
});
